export default {
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  productThumbStartingFrom: {
    id: 'product_thumb_starting_from',
    defaultMessage: 'Starting from',
  },
  productThumbCondition: {
    id: 'product_thumb_condition',
    defaultMessage: 'Condition: {grade}',
  },
  pthumbsWarrantyNew: {
    id: 'pthumbs_warranty_new',
    defaultMessage: 'Warranty: {warranty}',
  },
  originalPriceAriaLabel: {
    id: 'product_thumb_original_price_aria_label',
    defaultMessage: 'Instead of { originalPrice }',
  },
}
